<template>
  <section>
    <b-field :label="theme">
      <b-datepicker
          v-model="value"
          ref="datepicker"
          @input="updateDates"
          placeholder="Click to select a date"
          :min-date="minDateObject"
          :max-date="maxDateObject"
          :focused-date="focusedDate"
          :mobileNative="false"
          :events='events'
          :nearby-selectable-month-days="true"
          indicators="bars"
          range
      >
        Meeting days are marked above.
      </b-datepicker>
    </b-field>
  </section>
</template>

<script>
  var moment = require('moment');

  Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

  export default {
    name: 'DatePickerSearchRangeMeetings',
    data() {
      return {
        value: null,
      }
    },
    props: {
      theme: {
        type: String,
        default: ""
      },
      segmentType: String,
      minDate: String,
      maxDate: String,
    },
    computed: {
      minDateObject(){
        return moment(this.minDate).startOf('day').toDate();
      },
      maxDateObject() {
        return moment(this.maxDate).startOf('day').toDate();
      },
      focusedDate() {
        return this.minDateObject;
      },
      events(){
        let startMeeting = new Date(this.$store.state.meetings.meetingInfo.meeting.meetingStartDate);
        let endMeeting = new Date(this.$store.state.meetings.meetingInfo.meeting.meetingEndDate);
        let days = [];
        let i = startMeeting;
        while (i <= endMeeting) {
          i = i.addDays(1);
          days.push(i);
        }
        return days;
      },
    },
    methods: {
      updateDates(){
        this.$emit('input', this.value);
      },
    },
    mounted() {
    }
}
</script>

<style scoped>
</style>
